import { render, staticRenderFns } from "./fangchan.vue?vue&type=template&id=63f14c32&"
import script from "./fangchan.vue?vue&type=script&lang=js&"
export * from "./fangchan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports